<template>
  <div class="project container">
    <div class="banner container"></div>
    <!-- <div class="top_box">
      <div v-for="(item,i) in topList" :key="item.id" class="top_con">
        <div>
          <div>
            <span>{{item.num}}</span>
            <span class="unit_box">{{item.unit}}</span>
          </div>
          <div class="top_content">{{item.content}}</div>
        </div> -->
    <!-- <div class="line" v-if="i != topList.length"></div> -->
    <!--  </div>
    </div> -->
    <div class="list">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="item-left" v-if="item.status">
          <img :src="item.customerPic" alt="" />
        </div>
        <div class="item-right" v-if="item.status">
          <div class="title">{{ item.customerName }}</div>
          <div class="blue_line"></div>
          <div class="intro">
            <span>{{ item.caseIntroduction }}</span>
            <span style="position: absolute; bottom: 0; right: 0">
              <a href="javascript:void(0)" style="color: #1958c4" @click="viewDetail(item.id)">查看详情</a>
            </span>
          </div>
        </div>
      </div>
      <div style="padding: 40px 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="page.total"
          :page-size="page.pageSize"
          :current-page.sync="page.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      top="35vh"
      :title="detail.customerName"
      :visible.sync="show"
      width="700px"
      center
      :before-close="handleClose"
    >
      <div v-html="detail.caseDetails" style="font-size: 20px; line-height: 32px"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      detail: {},
      topList: [
        {
          num: '100',
          content: '完成市场智能化接入',
          unit: '个',
          id: '11'
        },
        {
          num: '100',
          content: '设备部署',
          unit: '套',
          id: '22'
        },
        {
          num: '100',
          content: '完成市场智能化接入',
          unit: '个',
          id: '33'
        },
        {
          num: '100',
          content: '完成市场智能化接入',
          unit: '个',
          id: '44'
        }
      ],
      list: [
        {
          id: 1,
          img: require('../assets/img/project.png'),
          title: '宁波农副产品物流中心',
          project:
            '宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心'
        },
        {
          id: 2,
          img: require('../assets/img/water.png'),
          title: '宁波水产品批发市场',
          project:
            '宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心'
        },
        {
          id: 3,
          img: require('../assets/img/binhai.png'),
          title: '滨海农副产品批发市场',
          project:
            '宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心'
        },
        {
          id: 4,
          img: require('../assets/img/anji.png'),
          title: '安吉农副产品综合批发市场',
          project:
            '宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心'
        },
        {
          id: 5,
          img: require('../assets/img/xinxiang.png'),
          title: '新乡农贸综合批发大市场',
          project:
            '宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心宁波农副产品物流中心'
        }
      ],
      page: {
        pageSize: 5,
        pageNum: 1,
        total: 0
      }
    }
  },
  beforeMount() {
    this.getList()
    this.show = false
  },
  methods: {
    getList() {
      this.$axios.post('api/hopdata-core/customer-case/page', this.page).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.records
          this.page.total = res.data.data.total
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getList()
    },
    viewDetail(id) {
      this.show = !this.show

      this.$axios.get(`api/hopdata-core/customer-case/detail?id=${id}`).then(res => {
        if (res.data.code == 200) {
          this.detail = res.data.data
          this.detail.caseDetails = decodeURIComponent(this.detail.caseDetails)
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-pagination button,
::v-deep .el-pager li {
  width: 50px !important;
  height: 50px !important;
  line-height: 50px;
}
::v-deep .el-dialog__title {
  font-size: 24px;
}
.container {
  width: 100%;
  margin: 0 auto;
}
.banner {
  background: url('../assets/img/banner_cpdj@2x.png') no-repeat center center;
  background-size: cover;
  height: 650px;
  margin-bottom: 40px;
}
.list {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 300px;
  justify-content: flex-end;
}
.item {
  display: flex;
  justify-content: center;
  width: 100%;
}
.item:nth-child(2n) {
  background: #f7fbff;
}
.item-left {
  width: 432px;
  height: 270px;
  margin-right: 48px;
  overflow: hidden;
  padding: 40px 0;
}
.item-left img {
  width: 100%;
  height: 100%;
  transition: 0.5s;
  cursor: pointer;
  object-fit: cover;
}
.item-left img:hover {
  transform: scale(1.1);
}
.item-right {
  width: 720px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 0;
}
.item-right .title {
  width: 720px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 30px;
  color: #1958c4;
  text-align: left;
}
.item-right .blue_line {
  width: 60px;
  height: 4px;
  background: #1958c4;
  margin: 12px 0 24px;
}
.item-right .intro {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 32px;
  text-align: justify;
  font-style: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 6;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  height: 160px;
  width: 100%;
  position: relative;
}

.top_box {
  width: 1200px;
  height: 200px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 50px;
  margin: -120px auto 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.line {
  width: 2px;
  height: 106px;
  background: rgba(0, 0, 0, 0.1);
}

.top_con {
  display: flex;
  align-items: center;
  width: 298px;
  text-align: center;
  justify-content: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.top_box .top_con:nth-child(4) {
  border-right: none;
}
.unit_box {
  font-size: 18px;
}

.top_content {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
</style>
